"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.TentativePhraseResultsOption = exports.OutputFormat = exports.PhraseExtension = exports.PhraseOption = void 0;
/**
 * The detailed output options.
 */
var PhraseOption;
(function (PhraseOption) {
    PhraseOption["WordTimings"] = "WordTimings";
    PhraseOption["SNR"] = "SNR";
    PhraseOption["Pronunciation"] = "Pronunciation";
    PhraseOption["WordPronunciation"] = "WordPronunciation";
    PhraseOption["WordConfidence"] = "WordConfidence";
    PhraseOption["Words"] = "Words";
    PhraseOption["Sentiment"] = "Sentiment";
    PhraseOption["PronunciationAssessment"] = "PronunciationAssessment";
    PhraseOption["ContentAssessment"] = "ContentAssessment";
    PhraseOption["PhraseAMScore"] = "PhraseAMScore";
    PhraseOption["PhraseLMScore"] = "PhraseLMScore";
    PhraseOption["WordAMScore"] = "WordAMScore";
    PhraseOption["WordLMScore"] = "WordLMScore";
    PhraseOption["RuleTree"] = "RuleTree";
    PhraseOption["NBestTimings"] = "NBestTimings";
    PhraseOption["DecoderDiagnostics"] = "DecoderDiagnostics";
    PhraseOption["DisplayWordTimings"] = "DisplayWordTimings";
    PhraseOption["DisplayWords"] = "DisplayWords";
})(PhraseOption = exports.PhraseOption || (exports.PhraseOption = {}));
/**
 * The detailed output extensions.
 */
var PhraseExtension;
(function (PhraseExtension) {
    PhraseExtension["Graph"] = "Graph";
    PhraseExtension["Corrections"] = "Corrections";
    PhraseExtension["Sentiment"] = "Sentiment";
})(PhraseExtension = exports.PhraseExtension || (exports.PhraseExtension = {}));
/**
 * The Recognition modes
 */
var OutputFormat;
(function (OutputFormat) {
    OutputFormat["Simple"] = "Simple";
    OutputFormat["Detailed"] = "Detailed";
})(OutputFormat = exports.OutputFormat || (exports.OutputFormat = {}));
/**
 * The Tentative Phrase Results option
 */
var TentativePhraseResultsOption;
(function (TentativePhraseResultsOption) {
    TentativePhraseResultsOption["None"] = "None";
    TentativePhraseResultsOption["Always"] = "Always";
})(TentativePhraseResultsOption = exports.TentativePhraseResultsOption || (exports.TentativePhraseResultsOption = {}));

//# sourceMappingURL=PhraseOutput.js.map
